import React from "react";
import { Redirect } from "react-router";
import { connect } from "react-redux";

import './Result.scss'

import * as actions from "../../../store/actions/index";
import { ACTION } from "../../../config/actions";

class Result extends React.Component {


  componentDidUpdate(previousProps) {
    console.log(previousProps);
    const {
      action: { date: prevDate },
    } = previousProps;
    const {
      action: { action, date },
    } = this.props;
    if (date !== prevDate) {
      this.handleKeyDown(action);
    }
  }

  handleKeyDown(action) {
    if (action === ACTION.START) {
      this.props.resetGame();
    }
  }

  resetGame = () => {
    this.props.resetGame();
  };

  render() {
    if (!this.props.isAuth) {
      return <Redirect to="/" />;
    }

    return (
      <div className="result-container py-8 text-center">
        <div className="result__display relative pt-4 mb-16">
          <div className="score-to absolute pin-t pin-l opacity-50">
            <p>{this.props.gameType} Game</p>
          </div>
          <div className="round-number absolute pin-t pin-r opacity-50">
            <p>{this.props.roundCount} Rounds</p>
          </div>
          <div
            className={
              "result__winner result__winner--" +
              this.props.winner.color +
              " py-8 mt-6"
            }
          >
            <h5 className="mb-4 uppercase">Winner</h5>
            <h1 className="mt-0 mb-8 winner-title-name">{this.props.winner.name}</h1>
            <p>PPD : {this.props.winner.ppd.toFixed(2)}</p>
          </div>
        </div>
        {/* <div className="result__summary px-4 mb-16">
          <div className="result__players flex flex-wrap -mx-6">
            {this.props.players.map((player, i) => (
              <div key={i} className="result__player w-1/2 px-2 mb-4">
                <div className={"result__player--" + player.color + " py-4"}>
                  <h5>{player.name}</h5>
                  <h1 className="my-4">{player.score}</h1>
                  <p>PPD : {player.ppd.toFixed(2)}</p>
                </div>
              </div>
            ))}
          </div>
        </div> */}
        {/* <div className="results__actions">
          <div className="result__action mx-auto w-1/2 px-2">
            <button
              className="button button--blue w-full"
              onClick={this.resetGame}
            >
              New Game
            </button>
          </div>
        </div> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.scoreboard,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetGame: () => dispatch(actions.resetGame()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Result);
